import { createAction, props } from '@ngrx/store';
import { IResponseBadRequest } from '@core/interfaces';
import { Coupon } from '@core/models'

export const COUPON_FIND_ALL = createAction('[Coupon] Find All');

export const COUPON_FIND_SUCCESS = createAction('[Coupon] Find Success', props<{ coupon: Coupon}>());
export const COUPON_VALIDATED_SUCCESS = createAction('[Coupon] Validated Success', props<{ coupon: Coupon}>());
export const COUPON_FIND_ALL_SUCCESS = createAction('[Coupon] Find All Success', props<{ couponList: Coupon[] }>());

export const COUPON_FAILURE = createAction('[Coupon] Failure', props<{ error: IResponseBadRequest }>());

export const COUPON_UPDATE_LOADING = createAction('[Coupon] Update Loading', props<{ loading: boolean }>());

export const COUPON_UPDATE_APPLIED = createAction('[Coupon] Update Applied', props<{ code: string }>());

export const COUPON_RESET = createAction('[Coupon] Reset');
export const COUPON_RESET_ERROR = createAction('[Coupon] Reset Error');
export const COUPON_CLEAR_STATE = createAction('[Coupon] Clear State');

export const COUPON_APPLY = createAction('[Coupon] Apply');

export const COUPON_VALID = createAction('[Coupon] Valid', props<{ coupon: Coupon }>());